import axios from 'axios';

const client = axios.create();
client.defaults.baseURL = process.env.API_TELEGRAM;

export default client;



// WEBPACK FOOTER //
// ./src/api/telegram.js